import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({ selector: "[lostFocus]" })
export class LostFocusDirective {
    @Output() focusLeft = new EventEmitter();

    isFocused: Boolean = false;

    constructor() {}

    @HostListener("focusin")
    onFocusIn() {
        this.isFocused = true;
    }

    @HostListener("focusout")
    onFocusOut() {
        this.isFocused = false;

        setTimeout(() => {
            if (!this.isFocused) {
                this.focusLeft.emit("lostFocus");
            }
        });
    }
}
